import script from "./PublicEventPresensi.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicEventPresensi.vue?vue&type=script&setup=true&lang=js"

import "./PublicEventPresensi.vue?vue&type=style&index=0&id=06bdb888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bdb888"]])

export default __exports__